import React, { useState, useEffect, useContext } from "react";
import { useDispatch } from "react-redux";
import axios from "axios";
import moment from "moment";
import { useHistory } from "react-router-dom";
import { Card, CardBody, Layout, Menu, Row, Col, Button, Space, message, Empty, Spin, Tag } from "antd";
import Icon, { LeftOutlined, RightOutlined, SearchOutlined, TrophyOutlined, DollarOutlined, MoneyCollectOutlined, DislikeOutlined, DislikeFilled, TagOutlined, NodeIndexOutlined, RiseOutlined, DashboardOutlined, ThunderboltOutlined, HeartOutlined, CompassOutlined, StarOutlined, ClockCircleOutlined, PlayCircleOutlined, PlayCircleFilled } from "@ant-design/icons";

import { setBreadcrumb } from "redux/actions/app.action";
import generalService from "services/general.service";
import generalHelper from "helper/general.helper";
import ActivityService from "services/activity.service";

import Header from "components/shared/Header";
import Filter from "components/overview/Filter";
import DataTable from "components/overview/DataTable";
import emptyImg from "assets/img/empty.svg";

import SearchModal from "components/overview/SearchModal";

import { SocketContext } from "contexts/SocketContext";
import { AppContext } from "contexts/AppContext";

import {
  CANCEL_REQUEST,
  DATE_TIME_FORMAT,
  FILE_TYPE,
  STATS_TYPE,
  WS_URL,
  TOKEN_NAME,
  VIEW_TYPE,
  SPORT_ICONS,
  CHART_COLOR_OPTION
} from "constants/index";

import AuthorizedFunction from "config/AuthorizedFunction";

const HeaderBar = () => {
  // const socket = useContext(SocketContext);
  const appContext = useContext(AppContext);
  // const [wsMessage, setWSMessage] = useState("");
  const [dateRange, setDateRange] = useState(null);
  const [openSearchModal, setOpenSearchModal] = useState(false);
  const [searchTags, setSearchTags] = useState([]);
  const dispatch = useDispatch();

  const history = useHistory();
  const goto = (path) => {
    redirect(path);
  };
  const redirect = (path) => {
    history.push({
      pathname: path.pathname,
    });
  };

  // useEffect(() => {
  //   socket.on("update-activity-list", (notes) => {
  //     if (notes) {
  //       setTableData(notes);
  //     } else {
  //       setTableData([]);
  //     }
  //   });
  //   dispatch(setBreadcrumb(["All listing"]));
  //   onSearch({ start: dateRange.startDate.format(DATE_TIME_FORMAT.DBDATE), end: dateRange.endDate.format(DATE_TIME_FORMAT.DBDATE) });
  // }, [socket, dateRange]);

  const selectedAthleteId = appContext.selectedAthlete?.athlete_id;

  useEffect(() => {
    dispatch(setBreadcrumb(["All listing"]));
    setSearchTags([]);
  }, [dateRange, appContext.dateRange, appContext.sportView, selectedAthleteId]);

  const handlePageView = () => {
    if (appContext.pageView === VIEW_TYPE.Week) {
      appContext.setPageView(VIEW_TYPE.Month);
      appContext.setDateRange({startDate: moment().startOf('month'), endDate: moment().endOf('month')});
    }
    else if (appContext.pageView === VIEW_TYPE.Month) {
      appContext.setPageView(VIEW_TYPE.Year);
      appContext.setDateRange({startDate: moment().startOf('year'), endDate: moment().endOf('year')});
    }
    else if (appContext.pageView === VIEW_TYPE.Year) {
      appContext.setPageView(VIEW_TYPE.Week);
      appContext.setDateRange({startDate: moment().startOf('isoWeek'), endDate: moment().endOf('isoWeek')});
    }
    else {
      appContext.setPageView(VIEW_TYPE.Week);
      appContext.setDateRange({startDate: moment().startOf('isoWeek'), endDate: moment().endOf('isoWeek')});
    }
  };

  const handleHomePage = () => {
    appContext.setSelectedAthlete(null);
    goto({ pathname: `/` });
  };

  const handleSearch = (values) => {
    const tags = [];
    if (values.activity_keyword) {
      tags.push({ key: "keyword", label: <TagOutlined />, value: values.activity_keyword });
    }
    if (values.activity_distance) {
      tags.push({ key: "distance", label: <NodeIndexOutlined />, value: `${values.activity_distance} km+` });
    }
    if (values.activity_elevation_gain) {
      tags.push({ key: "elevation_gain", label: <RiseOutlined />, value: `${values.activity_elevation_gain} m+` });
    }
    setSearchTags(tags);
  };

  const showSearchModal = () => {
    setOpenSearchModal(true);
  };

  const navData = (value) => {
    if (appContext.pageView === VIEW_TYPE.Week) {
      appContext.setDateRange({ startDate: moment(appContext.dateRange.startDate).add(value, 'weeks'), endDate: moment(appContext.dateRange.endDate).add(value, 'weeks')})
    }
    else if (appContext.pageView === VIEW_TYPE.Month) {
      appContext.setDateRange({ startDate: moment(appContext.dateRange.startDate).add(value, 'months'), endDate: moment(appContext.dateRange.endDate).add(value, 'months')})
    }
    else if (appContext.pageView === VIEW_TYPE.Year) {
      appContext.setDateRange({ startDate: moment(appContext.dateRange.startDate).add(value, 'years'), endDate: moment(appContext.dateRange.endDate).add(value, 'years')})
    }
  }

  const YearInSportButton = () => {
    if (appContext.selectedAthlete && appContext.selectedAthlete.athlete_id) {
      return (
        <button
          className="btn btn-primary btn-cmd"
          onClick={
            () => (window.location.href = `/year-in-sport/${appContext.selectedAthlete.athlete_id}/${appContext.dateRange.startDate.format(DATE_TIME_FORMAT.YEAR)}`)
          }
        >
          <TrophyOutlined />
        </button>
      );
    }
    return null;
  };

  const SearchButton = () => {
    if (appContext.selectedAthlete && appContext.selectedAthlete.athlete_id) {
      return (
        <button className="btn btn-primary btn-cmd" onClick={() => showSearchModal()}><SearchOutlined /></button>
      );
    }
    return null;
  };

  const PrevButton = () => {
    if (appContext.dateRange.startDate && !appContext.dateRange.startDate.isSameOrBefore(moment("2020-01-01"))) {
      return <button className="btn btn-primary btn-cmd" onClick={() => navData(-1)}><LeftOutlined /></button>
    } else {
      return <button className="btn btn-disabled btn-cmd" disabled><LeftOutlined /></button>
    }
  }

  const NextButton = () => {
    if (appContext.dateRange.endDate && !appContext.dateRange.endDate.isAfter(moment())) {
      return <button className="btn btn-primary btn-cmd" onClick={() => navData(1)}><RightOutlined /></button>
    } else {
      return <button className="btn btn-disabled btn-cmd" disabled><RightOutlined /></button>
    }
  }

  const CommandPanel = () => {
    return <span className="command-panel"><YearInSportButton/><SearchButton/><PrevButton/><NextButton/></span>
  }

  const renderAthleteBar = () => {
    if ((appContext.selectedAthlete || appContext.pageView === VIEW_TYPE.Back)) {
      return appContext.selectedAthlete && (
        <div className="header-bar athlete-bar">
          <button onClick={handleHomePage} className="btn-link"><LeftOutlined /></button>
          <img className="avatar" src={appContext.selectedAthlete.avatar} />
          <span className="athlete-name">
            <a href={`https://www.strava.com/athletes/${appContext.selectedAthlete.athlete_id}`}>
              {appContext.selectedAthlete.name}
            </a>
          </span>
          <div className="stats-info">
            <span className="additional-info"><NodeIndexOutlined /> {appContext.selectedAthlete.stats?.distance}</span>
            <span className="additional-info"><RiseOutlined /> {appContext.selectedAthlete.stats?.gain}</span>
            <span className="additional-info"><img src={SPORT_ICONS[appContext.sportView]} /> {appContext.selectedAthlete.stats?.activities}</span>
          </div>
        </div>
      )
    }
  }

  return (
    <div className="header-panel">
      <div className="header-bar">
        <button onClick={handlePageView} className="btn btn-primary btn-cmd">{appContext.pageView}</button>
        <span className="header-title">
          {
            searchTags.length > 0 ? searchTags.map((tag) => (
              <Tag key={tag.key} bordered={false} color="processing" className="search-tag">
                {tag.label} {tag.value}
              </Tag>
            )) :
            appContext.pageView === VIEW_TYPE.Week ? `${appContext.dateRange.startDate.format(DATE_TIME_FORMAT.DAY)} - ${appContext.dateRange.endDate.format(DATE_TIME_FORMAT.DATELONG)}` : 
            appContext.pageView === VIEW_TYPE.Month ? appContext.dateRange.endDate.format(DATE_TIME_FORMAT.MONTHLONG) : 
            appContext.pageView === VIEW_TYPE.Year ? appContext.dateRange.endDate.format(DATE_TIME_FORMAT.YEAR) : ""
          }
        </span>
        <CommandPanel />
      </div>
      { renderAthleteBar() }

      <SearchModal
        onUpdate={handleSearch}
        open={openSearchModal}
        onClose={setOpenSearchModal}
      />
    </div>
  );
};

export default HeaderBar;
